import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { TAG_PUBLISHER } from '../analytics/analytics.tagids.constants'
import { selectMapEventPopin, selectShouldDisplayMapEventPopin } from '../../store/map/map.selectors'
import { resetMapEventsPopin } from '../../store/map/mapSlice'
import { PUB_TAG } from '../analytics/PublisherTagsService'
import useImpressionTag from '../analytics/useImpressionTag'
import cross from '../genericComponents/assets/cross.svg'
import { withMapInitialized } from '../map/map.utils'
import SVGIcon from '../svg/SVGIcon'
import useEventCallback from '../utils/useEventCallback'
import s from './MapEventPopin.less'

const MapEventPopin = () => {
  const dispatch = useDispatch()
  const mapEventPopinInfo = useSelector(selectMapEventPopin)
  const shouldDisplayMapEventPopin = useSelector(selectShouldDisplayMapEventPopin)

  useImpressionTag(mapEventPopinInfo?.title, {
    type: TAG_PUBLISHER,
    tagInfo: { tag: PUB_TAG.PUB_MAP_LEGENDE_LAYER_CARTE, title_popin: mapEventPopinInfo?.title },
    isImpression: true
  })

  const onClick = useEventCallback(() => dispatch(resetMapEventsPopin()))

  if (!mapEventPopinInfo || !shouldDisplayMapEventPopin) return <></>

  const { title, description, asset_zone, asset_event } = mapEventPopinInfo

  return (
    <div className={s.container}>
      <SVGIcon url={asset_zone} className={s.asset} />
      <div className={s.textContainer}>
        <SVGIcon url={asset_event} className={s.logo} />
        <span className={s.title}>{title}</span>
        <span className={s.description}>{description}</span>
      </div>
      <div className={s.closeButton} onClick={onClick}>
        <SVGIcon url={cross} />
      </div>
    </div>
  )
}

export default withMapInitialized(MapEventPopin)
